import {Component, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {Http} from "@angular/http";
import {EbsWebService} from "../../services/ebsWebService";


@Component({
  selector: 'inputs',
  templateUrl: 'inputs.html',
  inputs: ['inputData']
})
export class InputPage implements AfterViewInit {

  inputData: any;
  dateValue: any;

  constructor(private cdRef:ChangeDetectorRef, public http: Http, public navCtrl: NavController, public navParams: NavParams, private _ebsWebService: EbsWebService) {
  }

  ngAfterViewInit(): void {
    if (typeof this.inputData.EditValue != "undefined" && this.inputData.EditValue != null) {
      this.dateValue = this.inputData.DisplayText;
      this.cdRef.detectChanges();
    }
  }

  updateValue(value,element) {
    if (typeof element.Action == "undefined" || element.Action == null) {
      return;
    }
    let params = element.PostParameters+value;
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);
    this._ebsWebService.postData(element.Action,postPayloadObject).toPromise().catch(error => {
      console.error(error);
    });

  }

}



// WEBPACK FOOTER //
// ./src/components/inputs/inputs.ts